import { useLazyQuery, useMutation } from "@apollo/client/react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useEffect, useState } from 'react';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { TextInput } from '../../../components/textInput/TextInput';
import { ListarMinutaDetalleDocs } from './ListarMinutaDetalleDocs';
import './listarMinutaGrilla.scss';

import moment from 'moment';
import toast from 'react-hot-toast';
import { ACTUALIZAR_PRECIO_MINUTA } from '../../../data/graphQL/mutations/ListarMinuta/actualizarPrecioMinuta';
import { JUSTIFICAR_MINUTA } from '../../../data/graphQL/mutations/ListarMinuta/justificarMinuta';
import { adaptListarMinutaJustificacionesArray, GET_LISTAR_MINUTA_JUSTIFICACIONES } from '../../../data/graphQL/queries/ListarMinuta/getListarMinutaJustificaciones';
import { formatCurrency } from "../../../utils/mathUtils";
import { ImprimirMinutaDetalleItems } from "../../ImprimirMinuta/components/ImprimirMinutaDetalleItems";

export const ListarMinutaDetalleContent = ({
  dataRegistro,
  setChildrenAction
}) => {


  const [justificaciones, setJustificaciones] = useState([]);
  const [itemsMinuta, setItemsMinuta] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [disabledPrecio, setDisabledPrecio] = useState(false);
  const [disabledJustificacion, setDisabledJustificacion] = useState(true);
  const [precioDiario, setPrecioDiario] = useState(dataRegistro?.precioDiario);
  const [precioTotal, setPrecioTotal] = useState(dataRegistro?.precioTotal);
  const [idJustificacion, setIdJustificacion] = useState(dataRegistro?.idJustificacionMinuta);

  const [getJustificaciones, { data: dataJustificaciones, loading: justificacionesLoading }] = useLazyQuery(GET_LISTAR_MINUTA_JUSTIFICACIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificaciones) return;
    const anioPrimerConexion = parseInt(moment(dataRegistro?.fechaPrimerConexion).format("YYYY"), 10);
    const opciones = adaptListarMinutaJustificacionesArray(dataJustificaciones.justificacionesMinuta);
    if (anioPrimerConexion >= 2024) {
      setJustificaciones(adaptListarMinutaJustificacionesArray(dataJustificaciones.justificacionesMinuta).filter((x) => x.idJustificacionMinuta >= 3));
    } else {
      setJustificaciones(adaptListarMinutaJustificacionesArray(dataJustificaciones.justificacionesMinuta).filter((x) => x.idJustificacionMinuta < 3));
    }
  }, [dataJustificaciones]);

  useEffect(() => {
    if (!justificacionesLoading) {
      getJustificaciones();
    }

    disabledButtons();
  }, []);

  useEffect(() => {
    setChildrenAction(() =>
      <>
        {
          dataRegistro?.fA &&
          <div className='chip-periodo'>
            <strong>La minuta fue generada de forma automática</strong>
          </div>
        }
      </>
    );
  }, [
    setChildrenAction]
  );

  const [justificarMinuta, { loading: justificarMinutaLoading }] = useMutation(JUSTIFICAR_MINUTA, {
    onCompleted: (data) => {
      if (data.justificarMinuta.success) {
        toast.success(data.justificarMinuta.valorEsperado);

        // deshabilito los botones de justificación y precio sap
        setDisabledPrecio(true);
        setDisabledJustificacion(true);
      } else {
        toast.error(data.justificarMinuta.valorEsperado);
      }
    }
  });

  const disabledButtons = () => {
    let disabledPrecio = true;
    let disabledJustificacion = true;

    if (dataRegistro.estadoPrecioMinuta != 2 &&
      precioDiario < dataRegistro.precioControl &&
      precioDiario < dataRegistro.precioSAP) {
      disabledPrecio = false;
    }

    if (precioDiario < dataRegistro?.precioSAP) {
      disabledJustificacion = false;
      disabledPrecio = false;
    }

    if (dataRegistro?.cotizado) {
      disabledJustificacion = true;
      disabledPrecio = true;

      if (dataRegistro?.estadoPrecioEvaluacion === 1) {

        // mostrar mensaje COTIZADO
      }
    }

    if (dataRegistro?.estadoPrecioMinuta > 0) {
      disabledJustificacion = true;
      disabledPrecio = true;
    }

    if (idJustificacion > 0) {
      disabledJustificacion = true;
      disabledPrecio = true;
    }

    setDisabledPrecio(disabledPrecio);
    setDisabledJustificacion(disabledJustificacion);
  };

  const [actualizarPrecioSAP, { loading: actualizarPrecioLoading }] = useMutation(ACTUALIZAR_PRECIO_MINUTA, {
    onCompleted: (data) => {
      if (data.actualizarPrecioMinuta.success) {
        toast.success(data.actualizarPrecioMinuta.valorEsperado);

        // deshabilito los botones de justificación y precio sap
        setDisabledPrecio(true);
        setDisabledJustificacion(true);

        // actualizo el precio diario y el total
        setPrecioDiario(dataRegistro?.precioSAP);
        setPrecioTotal(dataRegistro?.precioSAP * itemsMinuta.length);
      } else {
        toast.error(data.actualizarPrecioMinuta.valorEsperado);
      }
    }
  });

  const handleIgualarPrecioSAP = () => {
    actualizarPrecioSAP({
      variables: {
        idEvaluacion: dataRegistro?.idEvaluacion,
        idMinuta: dataRegistro?.idMinuta,
        precio: dataRegistro?.precioSAP
      }
    });
  };

  const isValidJustificar = () => {
    if (idJustificacion != null && idJustificacion <= 0) {
      toast.error("Debe seleccionar el motivo de Justificación.");
      return false;
    }
    return true;
  };

  const handleJustificar = () => {
    if (isValidJustificar()) {
      justificarMinuta({
        variables: {
          idMinuta: dataRegistro?.idMinuta,
          idJustificacion: idJustificacion
        }
      });
    }
  };

  return (
    <>
      <Grid container className='minuta-card-white' spacing={1}>
        <Grid size={{ md: 12 }}>
          <div className='section-title'>Minuta de Facturación</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Minuta Número</div>
          <div>{dataRegistro?.idMinuta}</div>
        </Grid>
        {dataRegistro?.codSAP != "" &&
          <Grid size={{ xs: 6, md: 3 }}>
            <div className='minuta-card-label'>Código SAP</div>
            <div>{dataRegistro?.codSAP}</div>
          </Grid>
        }
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Contrato</div>
          <div>{dataRegistro?.idEvaluacion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Fecha</div>
          <div>{moment(dataRegistro?.fechaAlta).format("DD/MM/YYYY HH:mm")}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Delegación</div>
          <div>{dataRegistro?.delegacion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Estado</div>
          <div>{dataRegistro?.estadoMinuta}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Número Factura</div>
          <div>{dataRegistro?.numeroFactura != '' ? dataRegistro?.numeroFactura : '-'}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Paciente</div>
          <div>{dataRegistro?.paciente}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Plan</div>
          <div>{dataRegistro?.planCuidado}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Cliente</div>
          <div>({dataRegistro?.codClienteSAP}) {dataRegistro?.cliente}</div>
        </Grid>
      </Grid>
      <br /><br />
      <Grid container className='minuta-card-white' spacing={1}>
        <Grid size={{ xs: 12, md: 12 }}>
          <div className='section-title'>Detalle</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Cantidad de Conexiones</div>
          <div>{dataRegistro?.cantidadConexion}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Precio Diario</div>
          <div>{formatCurrency(precioDiario)}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Precio Total</div>
          <div>{formatCurrency(precioTotal)}</div>
        </Grid>
        <Grid size={{ xs: 0, md: 3 }}>
          &nbsp;
        </Grid>
        <Grid size={{ xs: 6, md: 3 }}>
          <div className='minuta-card-label'>Precio SAP</div>
          <div>{formatCurrency(dataRegistro?.precioSAP)}</div>
        </Grid>
        <Grid size={{ xs: 6, md: 6 }}>
          <div className='minuta-card-label'>Precio Control</div>
          <div>{formatCurrency(dataRegistro?.precioControl)}</div>
        </Grid>
        {
          dataRegistro?.estadoMinuta == "Pendiente Facturar" &&
          <Grid size={{ xs: 12, md: 12 }}>
            <div style={{ display: 'flex', paddingTop: '10px' }}>
              <FormControl sx={{ backgroundColor: 'white', width: '30%' }} size="small">
                <InputLabel id="select-justificacion">Justificación</InputLabel>
                <Select
                  labelId="select-justificacion"
                  options={justificaciones}
                  label='Justificación'
                  onChange={(e) => setIdJustificacion(e.target.value)}
                  value={idJustificacion}
                  name='idJustificacion'
                  disabled={disabledJustificacion}>

                  {justificaciones && justificaciones.map((justificacion) => {
                    return <MenuItem key={justificacion.idJustificacionMinuta} value={justificacion.idJustificacionMinuta}> {justificacion.descripcion} </MenuItem>;
                  })}
                </Select>
              </FormControl>
              &nbsp;&nbsp;
              <CustomButton
                variant='outlined'
                isLoading={justificarMinutaLoading}
                disabled={disabledJustificacion}
                onClick={handleJustificar}>

                Justificar
              </CustomButton>
              &nbsp;&nbsp;
              <CustomButton
                variant='outlined'
                isLoading={actualizarPrecioLoading}
                disabled={disabledPrecio}
                onClick={handleIgualarPrecioSAP}>

                Igualar a Precio SAP
              </CustomButton>
            </div>
          </Grid>
        }
        <Grid size={{ xs: 12, md: 6 }}>
          <ImprimirMinutaDetalleItems
            dataRegistro={dataRegistro}
            itemsMinuta={itemsMinuta}
            setItemsMinuta={setItemsMinuta} />

        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ListarMinutaDetalleDocs
            dataRegistro={dataRegistro}
            documentos={documentos}
            setDocumentos={setDocumentos} />

        </Grid>
        <Grid size={{ xs: 12, md: 12 }} sx={{ marginTop: '10px' }}>
          <TextInput
            value={dataRegistro?.observaciones}
            label="Observaciones"
            placeholder="Observaciones"
            multiline
            rows={3}
            maxLength={2000}
            disabled={true} />

        </Grid>
      </Grid>
    </>);

};